var React = require('react');
var isURL = require('validator/lib/isURL');
var isEmail = require('validator/lib/isEmail');
var isMobilePhone = require('validator/lib/isMobilePhone');
var isNumeric = require('validator/lib/isNumeric');
var moment = require('moment');

const disableValidation = false;

const beginningOfTime = '1900-01-01';
const endOfTheWorld = '2150-01-01';

const required = (value) => {
    if (disableValidation) {
        return false;
    }

    return !value || !value.toString().trim().length ? 'Field is required' : false;
};

const bio = (value) => {
    if (disableValidation) {
        return false;
    }

    return value.toString().length > 8000 ? 'Bio must be less that 8000 characters' : false;
}

const url = (value) => {
    if (disableValidation) {
        return false;
    }

    return !isURL(value, { require_protocol: true }) ? 'Invalid url' : false;
}

const email = (value) => {
    if (disableValidation) {
        return false;
    }

    return !isEmail(value) ? 'Invalid email' : false;
};

const equal = (value, props) => {
    if (disableValidation) {
        return false;
    }

    return value !== props.compareValue ? 'Values must match' : false;
}

const password = (value, props) => {
    if (disableValidation) {
        return false;
    }

    var password = value;
    var invalidPasswordString = "Password invalid: ";

    if (password.length < 8) {
        return invalidPasswordString + "minimum 8 characters required";
    }

    if (password.length > 64) {
        return invalidPasswordString + "maximum 64 characters allowed";
    }

    let criteriaCount = 0;

    if (/[a-z]/.test(password)) {
        criteriaCount++;
    }

    if (/[A-Z]/.test(password)) {
        criteriaCount++;
    }

    if (/\d/.test(password)) {
        criteriaCount++;
    }

    if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        criteriaCount++;
    }

    if (criteriaCount < 3) {
        return invalidPasswordString + "must meet at least 3 of these criteria: uppercase letter, lowercase letter, number, special character";
    }

    return false;
};

const confirmPassword = (value, props) => {
    if (disableValidation) {
        return false;
    }

    if (value && value != props.originalpassword) {
        return "Passwords do not match";
    } 

    return false;
};


const phone = (value) => {
    if (disableValidation) {
        return false;
    }

    // their api returns "Ext." sometimes. exclude that from validation
    return !isMobilePhone(value ? value.replace('.', '').replace('Ext', '') : '', 'any') ? 'Invalid phone number' : false;
};

// TODO - after soft launch, create separate input for phone extension
// Their api accepts 25 characters for phone + 20 for extension
// so temporarily restrict to 45 characters while we only have one input
const phoneLength = (value) => {
    if (disableValidation) {
        return false;
    }

    return value && value.length > 45 ? 'Invalid phone number' : false;
}

const npiNumber = (value) => {
    if (disableValidation) {
        return false;
    }

    if (typeof(value) === 'undefined' || value === '') return false;

    // saw both strings and ints coming back from api, using toString() to avoid problems
      return value && (!isValidNPI(value))? 'Invalid NPI Number' : false;
}


function isValidNPI(npi) {

    npi = npi.toString(); 

    if (!npi || isNaN(npi) || npi.toString().length < 10 || !isNumeric(npi.toString())) {
        return false;
    }

    if (npi.length === 15 && npi.startsWith("80840")) {
        let sum = 0;
        for (let i = 0; i < npi.length; i++) {
            let digit = parseInt(npi[i], 10);

            // Double every second digit starting from the right
            if (i % 2 === npi.length % 2) {
                digit *= 2;

                // If doubling results in a number greater than 9, subtract 9
                if (digit > 9) {
                    digit -= 9;
                }
            }

            sum += digit;
        }

        return sum % 10 === 0;
    } else {
        let number = Array.from(npi).map(char => parseInt(char, 10));

        let sum = sumDigits(number[8] * 2) + sumDigits(number[6] * 2) + sumDigits(number[4] * 2) + sumDigits(number[2] * 2) + sumDigits(number[0] * 2) + 24;
        sum += number[1] + number[3] + number[5] + number[7];

        if (sum % 10 !== 0) {
            sum = (sum + (10 - (sum % 10))) - sum;
        } else {
            sum = 0;
        }

        return sum === number[9];
    }
}

function sumDigits(number) {
    let sum = 0;
    while (number > 0) {
        sum += number % 10;
        number = Math.floor(number / 10);
    }
    return sum;
}


const boardCertificationNumber = (value, props) => {
    if (disableValidation) {
        return false;
    }

    var compareVal = value ? value.toString() : '';
    if (props.boardId === "AOBA_ID" || props.boardId === "AOBA") {
        return compareVal.length > 12 || !isNumeric(compareVal) ? 'Invalid Certification Number' : false;
    }
    else {
        return compareVal.length !== 8 || !isNumeric(compareVal) ? 'Invalid Certification Number' : false;
    }
}

const emailType = (value, props) => {
    if (disableValidation) {
        return false;
    }

    if (!props.disabled) {
        var match = props.allemailtypes.filter(function(item) {
            return item && item === value;
        }.bind(this));

        return match && match.length ? 'An email of that type already exists' : false;
    }
};

const date = (value) => {
    if (disableValidation) {
        return false;
    }

    if (!value) {
        return false;
    }

    return moment.utc(value).isValid()
        && moment.utc(value) > moment.utc(beginningOfTime)
        && moment.utc(value) < moment.utc(endOfTheWorld)
        ? false : 'Must be a valid date';
}

const expirationDate = (value) => {
    if (disableValidation) {
        return false;
    }

    if (value === "" || value === "0001-01-01") return false;

    return moment.utc(value).isValid()
        && moment.utc(value) > moment.utc(beginningOfTime)
        && moment.utc(value) < moment.utc(endOfTheWorld)
        && moment.utc(value) > moment.utc(new Date())
        ? false : 'Date must be greater than ' + new Date().toLocaleDateString();
}

const expirationYear = (value) => {
    if (disableValidation) {
        return false;
    }

    return !isNumeric(value) || (value && value.length !== 4) || (moment.utc(new Date()).year() > value) ? "Invalid Year" : false;
}

// should return error if start date is not less than end date
const dateLessThan = (value, props) => {
    if (disableValidation) {
        return false;
    }

    if (!value) {
        return false;
    }

    var compare = props.comparetodate ? moment.utc(props.comparetodate) : null;

    if (compare) {
        return moment.utc(value) > compare && moment.utc(props.comparetodate).format('YYYY-MM-DD') !== '0001-01-01' ? 'Must be less than end date' : false;
    }

    return false;
}

// should return error if the date is later than today; today itself is allowed
const dateNotInTheFuture = (value) => {
    if (disableValidation) {
        return false;
    }

    if (!value) {
        return false;
    }

    var selected = moment.utc(value);

    if (!selected.isValid()) {
        return false;
    }

    return selected.format('YYYY-MM-DD') > moment().format('YYYY-MM-DD') ? 'Date cannot be in the future' : false;
}

// should return error if the date is today or later; today is not allowed
const dateBeforeToday = (value) => {
    if (disableValidation) {
        return false;
    }

    if (!value) {
        return false;
    }

    var selected = moment.utc(value);

    if (!selected.isValid()) {
        return false;
    }

    return selected.format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD') ? 'Date must be before today' : false;
}

const dobMinAgeYears = 17;
const dobMaxAgeYears = 100;

// youngest allowed DOB: today minus 17 years (exactly 17 is allowed)
const getDobMaxDate = function() {
    return moment().subtract(dobMinAgeYears, 'years').format('YYYY-MM-DD');
};

// oldest allowed DOB: the day after 101 years ago (age 100 inclusive, 101 not allowed)
const getDobMinDate = function() {
    return moment().subtract(dobMaxAgeYears + 1, 'years').add(1, 'day').format('YYYY-MM-DD');
};

// should return error if age is outside 17-100 years
const dateOfBirthAgeRange = (value) => {
    if (disableValidation) {
        return false;
    }

    if (!value) {
        return false;
    }

    var selected = moment.utc(value);

    if (!selected.isValid()) {
        return false;
    }

    var selectedDate = selected.format('YYYY-MM-DD');

    return selectedDate < getDobMinDate() || selectedDate > getDobMaxDate()
        ? 'Age must be between 17 and 100 years'
        : false;
}

// should return error if the date is today or earlier
const dateInTheFuture = (value) => {
    if (disableValidation) {
        return false;
    }

    if (!value) {
        return false;
    }

    var selected = moment.utc(value);

    if (!selected.isValid()) {
        return false;
    }

    return selected.format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD') ? 'Date must be in the future' : false;
}

// should error if end date is not greater than start date
const dateGreaterThan = (value, props) => {
    if (disableValidation) {
        return false;
    }

    if (!value) {
        return false;
    }

    var compare = props.comparetodate ? moment.utc(props.comparetodate) : null;

    if (compare) {
        return moment.utc(value) < compare ? 'Must be greater than start date' : false;
    }

    return false;
}

const fellowShipFieldRequired = (value, props) => {
    if (disableValidation) {
        return false;
    }

    if (props.programtype === 'Fellowship Training') {
        return !value || !value.toString().trim().length ? 'Fellowship type is required' : false;
    }
};

const addressType = (value, props) => {
    if (disableValidation) {
        return false;
    }

    if (!props.disabled) {
        var match = props.alladdresstypes.filter(function(item) {
            return item && item === value;
        }.bind(this));

        return match && match.length ? 'Address type is required and must be unique' : false;
    }
};

const phoneLocation = (value, props) => {
    if (disableValidation) {
        return false;
    }

    if (!props.disabled) {
        var match = props.allphonelocations.filter(function(item) {
            return item && item === value;
        }.bind(this));

        return match && match.length ? 'A phone for that location already exists' : false;
    }
};

const jobTitleLength = (value) => {
    if (disableValidation) {
        return false;
    }

    return value && value.length > 90 ? 'Length should not exceed 90 characters' : false;
};

module.exports = {
    bio: bio,
    boardCertificationNumber: boardCertificationNumber,
    date: date,
    dateGreaterThan: dateGreaterThan,
    dateBeforeToday: dateBeforeToday,
    dateOfBirthAgeRange: dateOfBirthAgeRange,
    dateNotInTheFuture: dateNotInTheFuture,
    getDobMinDate: getDobMinDate,
    getDobMaxDate: getDobMaxDate,
    dateInTheFuture: dateInTheFuture,
    dateLessThan: dateLessThan,
    expirationDate: expirationDate,
    expirationYear: expirationYear,
    required: required,
    emailType: emailType,
    email: email,
    equal: equal,
    phone: phone,
    phoneLength: phoneLength,
    addressType: addressType,
    phoneLocation: phoneLocation,
    npiNumber: npiNumber,
    fellowShipFieldRequired: fellowShipFieldRequired,
    password: password,
    confirmPassword: confirmPassword,
    url: url,
    jobTitleLength: jobTitleLength
};